import { initRequest } from 'apis/MCBQS030Api'
import { openModal } from 'reducers/messageReducer'
import {
  getInitDataForDownload,
  initEventRespons,
} from 'reducers/setOutputPdfDownloadReducer'
import { all, call, put, takeEvery } from 'redux-saga/effects'

// MCBQS030
function* getInitDataForDownloadSaga(
  action: ReturnType<typeof getInitDataForDownload>
) {
  try {
    const response = yield call(initRequest, action.payload)
    yield put(initEventRespons(response))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

export default function* setOutputPdfDownloadSaga() {
  yield all([
    takeEvery(getInitDataForDownload, getInitDataForDownloadSaga),
  ])
}
